import React from "react";
import { HugeiconsIcon } from "@hugeicons/react";
import {
  ArrowDown01Icon,
  ArrowRight02Icon,
  SidebarLeftIcon,
} from "@hugeicons-pro/core-stroke-rounded";
import type { DsIconOverrides } from "@outpave/ds";

/**
 * Icon overrides threaded into `createOutpaveTheme` (D6).
 *
 * The package registry defaults to MUI's Rounded family, which is filled. The
 * app and the prototypes draw nav chrome with the outlined hugeicons set, so a
 * filled glyph reads as a different weight beside everything around it. Only
 * the slots we actually notice are overridden; the rest keep the default.
 */
export const dsIcons: DsIconOverrides = {
  // `ViewSidebarRounded` is solid; the prototype's collapse toggle is this.
  sidebar: ({ size, ...rest }) => (
    <HugeiconsIcon icon={SidebarLeftIcon} size={size} {...rest} />
  ),
  // The default is MUI's filled triangle, which reads as a different weight
  // beside the stroked glyphs every field around it uses.
  chevronDown: ({ size, ...rest }) => (
    <HugeiconsIcon icon={ArrowDown01Icon} size={size} {...rest} />
  ),
  // The package Card's "view all" arrow, drawn as the dashboard's arrows always were.
  arrowRight: ({ size, ...rest }) => (
    <HugeiconsIcon icon={ArrowRight02Icon} size={size} {...rest} />
  ),
};

export default dsIcons;
